// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-range-bar {
  margin-bottom: 12px;
}

.date-range-chips {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.date-range-bar .chip {
  min-height: 32px;
  padding: 4px 10px;
  border: 1px solid var(--vb-border);
  border-radius: 999px;
  background: var(--vb-surface);
  color: var(--vb-text-muted);
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.date-range-bar .chip.active {
  background: var(--vb-navy);
  border-color: transparent;
  color: #fff;
}

body.night-mode .date-range-bar .chip.active {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
}

.day-stepper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 10px 0 8px;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 12px;
  padding: 4px;
}

.day-step {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  color: var(--vb-text);
  border-radius: 10px;
  cursor: pointer;
}

.day-step:hover:not(:disabled) {
  background: var(--vb-surface-hover);
}

.day-step:disabled {
  opacity: 0.35;
  cursor: default;
}

.day-step-label,
.date-range-label {
  font-size: 13px;
  font-weight: 750;
  text-align: center;
  color: var(--vb-text);
}

.date-range-label {
  margin: 8px 0;
}

.date-range-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.date-range-fields label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 11px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.date-range-fields input {
  min-height: 40px;
  padding: 6px 8px;
  border: 1px solid var(--vb-border);
  border-radius: 8px;
  background: var(--vb-surface);
  color: var(--vb-text);
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/components/DateRangeBar.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":[".date-range-bar {\n  margin-bottom: 12px;\n}\n\n.date-range-chips {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.date-range-bar .chip {\n  min-height: 32px;\n  padding: 4px 10px;\n  border: 1px solid var(--vb-border);\n  border-radius: 999px;\n  background: var(--vb-surface);\n  color: var(--vb-text-muted);\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.date-range-bar .chip.active {\n  background: var(--vb-navy);\n  border-color: transparent;\n  color: #fff;\n}\n\nbody.night-mode .date-range-bar .chip.active {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n}\n\n.day-stepper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin: 10px 0 8px;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 12px;\n  padding: 4px;\n}\n\n.day-step {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: transparent;\n  color: var(--vb-text);\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.day-step:hover:not(:disabled) {\n  background: var(--vb-surface-hover);\n}\n\n.day-step:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n.day-step-label,\n.date-range-label {\n  font-size: 13px;\n  font-weight: 750;\n  text-align: center;\n  color: var(--vb-text);\n}\n\n.date-range-label {\n  margin: 8px 0;\n}\n\n.date-range-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.date-range-fields label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.date-range-fields input {\n  min-height: 40px;\n  padding: 6px 8px;\n  border: 1px solid var(--vb-border);\n  border-radius: 8px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
